import React from "react";

import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import ValidadeAlunoCurso from "../../../../components/Admin/AlunosUpdate/ValidadeCurso";
import { withRouter } from "react-router-dom";

import {
  Container,
  ContentSquad,
  Title,

} from "./styled";


function ValidadeCurso() {

  return (
      <Container>
        <AdminMenu />
        <Title>Alterar Validade de Curso do Aluno</Title>
        <ContentSquad>
        <ValidadeAlunoCurso/>
        </ContentSquad>
        
      </Container>
  );
}

export default withRouter(ValidadeCurso);
